var map = {
	"./404.png": [
		93262,
		3262
	],
	"./access.png": [
		62786,
		2786
	],
	"./apk.png": [
		55356,
		5356
	],
	"./appStore.png": [
		67676,
		7676
	],
	"./back.jpg": [
		59925,
		9925
	],
	"./bemFoundation.webp": [
		4069,
		4069
	],
	"./bemLogo.png": [
		3515,
		3515
	],
	"./blackLogo.png": [
		38874,
		8874
	],
	"./blogs/bcn.jpg": [
		53701,
		3701
	],
	"./blogs/benefits/cta1.jpg": [
		20992,
		992
	],
	"./blogs/benefits/cta2.jpg": [
		34607,
		4607
	],
	"./blogs/benefits/cta3.jpg": [
		66674,
		6674
	],
	"./blogs/crowdfunding.webp": [
		6136,
		6136
	],
	"./blogs/goals.jpg": [
		23016,
		3016
	],
	"./blogs/header.jpg": [
		51845,
		1845
	],
	"./blogs/icons/debt.svg": [
		74804,
		4804
	],
	"./blogs/icons/equity.svg": [
		4230,
		4230
	],
	"./blogs/icons/financialAssistance.svg": [
		46780,
		6780
	],
	"./blogs/icons/reward.svg": [
		39534,
		9534
	],
	"./blogs/logos/bcn.png": [
		10568,
		568
	],
	"./blogs/logos/bem.png": [
		75445,
		5445
	],
	"./blogs/logos/bemchain.png": [
		10846,
		846
	],
	"./blogs/logos/bemex.png": [
		43694,
		3694
	],
	"./blogs/logos/bemgames.png": [
		90240,
		240
	],
	"./blogs/logos/bemib.png": [
		48848,
		8848
	],
	"./blogs/logos/bempay.png": [
		78343,
		8343
	],
	"./blogs/logos/bempire.png": [
		54731,
		4731
	],
	"./blogs/logos/bemulator.png": [
		7842,
		7842
	],
	"./blogs/logos/tim.png": [
		79643,
		9643
	],
	"./blogs/marketmaker.jpg": [
		74208,
		4208
	],
	"./blogs/mmpworld.jpg": [
		5368,
		5368
	],
	"./blogs/risks.jpg": [
		57768,
		7768
	],
	"./bonus/blackFriday.jpg": [
		58786,
		8786
	],
	"./bonus/xmas.jpg": [
		90513,
		513
	],
	"./cards/back.webp": [
		82863,
		2863
	],
	"./cards/black.webp": [
		41943,
		1943
	],
	"./cards/blue.webp": [
		264,
		264
	],
	"./cards/elite.webp": [
		47631,
		7631
	],
	"./cards/exclusive.webp": [
		30140,
		140
	],
	"./cards/excutive.webp": [
		31843,
		1843
	],
	"./cards/growth.webp": [
		90139,
		139
	],
	"./cards/mmi.webp": [
		18389,
		8389
	],
	"./cards/mmi_white.webp": [
		15247,
		5247
	],
	"./cards/premier.webp": [
		49056,
		9056
	],
	"./cards/purple.webp": [
		23618,
		3618
	],
	"./cards/red.webp": [
		32323,
		2323
	],
	"./cards/royal.webp": [
		56751,
		9132
	],
	"./cards/smart.webp": [
		89961,
		9961
	],
	"./cards/start.webp": [
		53512,
		3512
	],
	"./cards/white.webp": [
		85053,
		5053
	],
	"./cards/white_back.webp": [
		9205,
		9205
	],
	"./circle.png": [
		91104,
		1104
	],
	"./comingSoon.png": [
		56860,
		6860
	],
	"./contract/p1.png": [
		31046,
		1046
	],
	"./contract/p10.png": [
		84084,
		4084
	],
	"./contract/p11.png": [
		5213,
		5213
	],
	"./contract/p12.png": [
		80326,
		326
	],
	"./contract/p13.png": [
		2991,
		2991
	],
	"./contract/p14.png": [
		76496,
		6496
	],
	"./contract/p15.png": [
		73401,
		3401
	],
	"./contract/p2.png": [
		12253,
		2253
	],
	"./contract/p3.png": [
		79220,
		9220
	],
	"./contract/p4.png": [
		51512,
		9131
	],
	"./contract/p5.png": [
		8002,
		8002
	],
	"./contract/p6.png": [
		64089,
		4089
	],
	"./contract/p7.png": [
		57840,
		7840
	],
	"./contract/p8.png": [
		77751,
		7751
	],
	"./contract/p9.png": [
		32174,
		2174
	],
	"./contract/submit.png": [
		6519,
		6519
	],
	"./contract/true.png": [
		79351,
		9351
	],
	"./dashboard.webp": [
		29576,
		9576
	],
	"./diamonds/black.webp": [
		69601,
		9601
	],
	"./diamonds/blue.webp": [
		65750,
		5750
	],
	"./diamonds/elite.webp": [
		63981,
		3981
	],
	"./diamonds/exclusive.webp": [
		87214,
		7214
	],
	"./diamonds/executive.webp": [
		9084,
		9084
	],
	"./diamonds/growth.webp": [
		18677,
		8677
	],
	"./diamonds/mmi_false.webp": [
		11175,
		1175
	],
	"./diamonds/mmi_true.webp": [
		31404,
		1404
	],
	"./diamonds/premier.webp": [
		74662,
		4662
	],
	"./diamonds/purple.webp": [
		77896,
		7896
	],
	"./diamonds/red.webp": [
		76821,
		6821
	],
	"./diamonds/royal.webp": [
		7941,
		7941
	],
	"./diamonds/smart.webp": [
		61135,
		1135
	],
	"./diamonds/start.webp": [
		69198,
		9198
	],
	"./diamonds/white.webp": [
		36831,
		6831
	],
	"./error.png": [
		17376,
		7376
	],
	"./false.png": [
		11971,
		1971
	],
	"./festival/EidToEid/bg.jpg": [
		36180,
		6180
	],
	"./festival/EidToEid/dates.svg": [
		23308,
		3308
	],
	"./festival/EidToEid/text.svg": [
		32676,
		2676
	],
	"./festival/anniversary.svg": [
		91771,
		1771
	],
	"./festival/appreciation/date.svg": [
		5145,
		5145
	],
	"./festival/appreciation/logo.svg": [
		29760,
		9760
	],
	"./festival/bg.jpg": [
		60548,
		8167
	],
	"./festival/bg.webp": [
		86054,
		6054
	],
	"./festival/blackFriday/bg.webp": [
		32355,
		2355
	],
	"./festival/blackFriday/date.svg": [
		99872,
		9872
	],
	"./festival/blackFriday/description.svg": [
		10250,
		250
	],
	"./festival/blackFriday/logo.svg": [
		31065,
		1065
	],
	"./festival/blackFriday/logo.webp": [
		31431,
		1431
	],
	"./festival/boosterSpeed/bg.webp": [
		72720,
		2720
	],
	"./festival/boosterSpeed/date.svg": [
		35157,
		5157
	],
	"./festival/boosterSpeed/logo.webp": [
		66440,
		6440
	],
	"./festival/dates.png": [
		81154,
		1154
	],
	"./festival/dates.svg": [
		39922,
		9922
	],
	"./festival/gala/bg.jpg": [
		28644,
		8644
	],
	"./festival/gala/bgMob.jpg": [
		9748,
		9748
	],
	"./festival/gala/dates.svg": [
		90484,
		484
	],
	"./festival/gala/extended.png": [
		13890,
		3890
	],
	"./festival/gala/img.png": [
		79380,
		9380
	],
	"./festival/gala/imgMob.png": [
		67804,
		7804
	],
	"./festival/gala/timeline.svg": [
		97792,
		7792
	],
	"./festival/gala/title.png": [
		56803,
		6803
	],
	"./festival/goldenFuture/date.webp": [
		93356,
		3356
	],
	"./festival/goldenFuture/date2.webp": [
		31966,
		1966
	],
	"./festival/goldenFuture/logo.webp": [
		26055,
		6055
	],
	"./festival/goldenFuture/logoMob.webp": [
		95619,
		5619
	],
	"./festival/img.png": [
		2068,
		2068
	],
	"./festival/logo.png": [
		69184,
		9184
	],
	"./festival/newSeason/bgDesktop.webp": [
		40522,
		522
	],
	"./festival/newSeason/bgMobile.webp": [
		39024,
		9024
	],
	"./festival/newSeason/date.svg": [
		52983,
		2983
	],
	"./festival/newSeason/logo.svg": [
		68018,
		8018
	],
	"./festival/newSeason/title.svg": [
		38375,
		8375
	],
	"./festival/newYear/date.svg": [
		32131,
		2131
	],
	"./festival/newYear/logo.webp": [
		44570,
		4570
	],
	"./festival/newYear/mobileLogo.webp": [
		74676,
		4676
	],
	"./festival/newYear/title.svg": [
		56307,
		6307
	],
	"./festival/newYear/webLogo.webp": [
		66398,
		1160
	],
	"./festival/ramadanToNowruz/date.webp": [
		74222,
		4222
	],
	"./festival/ramadanToNowruz/logo.webp": [
		32637,
		2637
	],
	"./festival/spring404/dates.svg": [
		83822,
		3822
	],
	"./festival/spring404/logo.webp": [
		85622,
		5622
	],
	"./festival/title.svg": [
		83355,
		3355
	],
	"./festival/title.webp": [
		81825,
		1825
	],
	"./festival/xLogo.png": [
		60652,
		652
	],
	"./flagship/1.svg": [
		91404,
		9023
	],
	"./flagship/2.svg": [
		46751,
		6751
	],
	"./flagship/3.svg": [
		41998,
		1998
	],
	"./flagship/bg.jpg": [
		524,
		524
	],
	"./flagship/cup.svg": [
		48653,
		8653
	],
	"./flagship/empire.svg": [
		17935,
		7935
	],
	"./flagship/logo.svg": [
		69286,
		9286
	],
	"./flagship/noAkhtaran.svg": [
		63942,
		3942
	],
	"./flagship/ticket.svg": [
		27695,
		7695
	],
	"./flagship/vsKit.png": [
		53322,
		3322
	],
	"./flagship/vsKitM.png": [
		59413,
		9413
	],
	"./goPro/bronze.svg": [
		23214,
		3214
	],
	"./goPro/gold.svg": [
		51388,
		1388
	],
	"./goPro/gp4Logo1.png": [
		3913,
		3913
	],
	"./goPro/gp4Logo2.png": [
		38770,
		8770
	],
	"./goPro/money.svg": [
		29610,
		9610
	],
	"./goPro/silver.svg": [
		54793,
		4793
	],
	"./goPro/ticket.svg": [
		2198,
		2198
	],
	"./goPro/top20.svg": [
		14689,
		4689
	],
	"./goPro/vipTicket.svg": [
		40427,
		427
	],
	"./google.png": [
		1817,
		1817
	],
	"./gopro.jpg": [
		16069,
		6069
	],
	"./gopro3.png": [
		93530,
		3530
	],
	"./headers/DEFIWallet.webp": [
		39336,
		9336
	],
	"./headers/Genealogy.webp": [
		98008,
		8008
	],
	"./headers/NFTWallet.webp": [
		68660,
		8660
	],
	"./headers/activationHistory.webp": [
		14041,
		4041
	],
	"./headers/activeInvestments.webp": [
		6425,
		6425
	],
	"./headers/addendumRequest.webp": [
		33702,
		3702
	],
	"./headers/bcninvestment.webp": [
		4471,
		4471
	],
	"./headers/binaryOption.webp": [
		26963,
		6963
	],
	"./headers/bonus.webp": [
		86989,
		9370
	],
	"./headers/buyNFTRequest.webp": [
		85840,
		5840
	],
	"./headers/buyTokenRequest.webp": [
		86867,
		6867
	],
	"./headers/changeLoginPassword.webp": [
		48233,
		8233
	],
	"./headers/corporateSocialResponsibility.webp": [
		73887,
		3887
	],
	"./headers/cryptoDeposit.webp": [
		45988,
		5988
	],
	"./headers/cryptoDepositHistory.webp": [
		84316,
		4316
	],
	"./headers/currentDepositHistory.webp": [
		2414,
		2414
	],
	"./headers/customerSupport.webp": [
		74726,
		4726
	],
	"./headers/debts.webp": [
		12351,
		2351
	],
	"./headers/defiHistory.webp": [
		82331,
		2331
	],
	"./headers/defiInvestment.webp": [
		31464,
		1464
	],
	"./headers/depositsPortals.webp": [
		64195,
		4195
	],
	"./headers/discountHistory.webp": [
		58004,
		8004
	],
	"./headers/donate.webp": [
		90624,
		624
	],
	"./headers/downlines.webp": [
		84630,
		4630
	],
	"./headers/downloadApp.webp": [
		8398,
		8398
	],
	"./headers/downloadMT4.webp": [
		87530,
		7530
	],
	"./headers/earlyTermination.webp": [
		98460,
		8460
	],
	"./headers/flagshipBattle.webp": [
		99361,
		9361
	],
	"./headers/foreignExchange.webp": [
		4652,
		4652
	],
	"./headers/forexHistory.webp": [
		65145,
		7526
	],
	"./headers/forexWallet.webp": [
		97602,
		5221
	],
	"./headers/goPro1.webp": [
		91311,
		1311
	],
	"./headers/goPro2.webp": [
		14670,
		4670
	],
	"./headers/goPro3.webp": [
		10697,
		697
	],
	"./headers/goPro4.webp": [
		34192,
		4192
	],
	"./headers/goldenRewardWallet.webp": [
		92256,
		2256
	],
	"./headers/googleAuthenticator.webp": [
		23251,
		3251
	],
	"./headers/headers_webp.zip": [
		49609,
		9609
	],
	"./headers/home.webp": [
		93968,
		3968
	],
	"./headers/incomeHistory.webp": [
		87584,
		7584
	],
	"./headers/installmentPayment.webp": [
		36080,
		6080
	],
	"./headers/installmentsTable.webp": [
		2201,
		2201
	],
	"./headers/insuranceContract.webp": [
		33683,
		3683
	],
	"./headers/insuranceDashboard.webp": [
		57611,
		7611
	],
	"./headers/insuranceTermination.webp": [
		89725,
		9725
	],
	"./headers/internalExchange.webp": [
		5299,
		5299
	],
	"./headers/internalTransfer.webp": [
		57741,
		7741
	],
	"./headers/investmentDashboard.webp": [
		19246,
		9246
	],
	"./headers/investmentHistory.webp": [
		57782,
		7782
	],
	"./headers/investmentPackage.webp": [
		15294,
		5294
	],
	"./headers/kyc.webp": [
		5424,
		5424
	],
	"./headers/liquidityPool.webp": [
		71299,
		1299
	],
	"./headers/luckySpin.webp": [
		87397,
		7397
	],
	"./headers/mT4Wallet.webp": [
		4019,
		4019
	],
	"./headers/masterCardApplication.webp": [
		42467,
		2467
	],
	"./headers/membersLoan.webp": [
		14432,
		4432
	],
	"./headers/migrate.webp": [
		5320,
		5320
	],
	"./headers/millionairesChallenge.webp": [
		50932,
		932
	],
	"./headers/mmb.webp": [
		24017,
		4017
	],
	"./headers/mmc.webp": [
		23990,
		3990
	],
	"./headers/mmf.webp": [
		17637,
		7637
	],
	"./headers/mt4History.webp": [
		7518,
		7518
	],
	"./headers/myPackages.webp": [
		86484,
		6484
	],
	"./headers/networkView.webp": [
		34266,
		4266
	],
	"./headers/news.webp": [
		3648,
		3648
	],
	"./headers/nftHistory.webp": [
		2135,
		2135
	],
	"./headers/personalDonate.webp": [
		66400,
		1638
	],
	"./headers/privacyPolicy.webp": [
		58503,
		8503
	],
	"./headers/profile.webp": [
		17812,
		7812
	],
	"./headers/purchaseInsurance.webp": [
		52888,
		2888
	],
	"./headers/purchasePackage.webp": [
		20868,
		868
	],
	"./headers/raw.webp": [
		22155,
		2155
	],
	"./headers/securityPassword.webp": [
		41776,
		1776
	],
	"./headers/sellCurrentDeposit.webp": [
		42818,
		2818
	],
	"./headers/sellHistory.webp": [
		21277,
		1277
	],
	"./headers/sponsorGenealogy.webp": [
		8152,
		8152
	],
	"./headers/stars.webp": [
		26084,
		6084
	],
	"./headers/stockMarket.webp": [
		73539,
		3539
	],
	"./headers/submitAccount.webp": [
		47818,
		7818
	],
	"./headers/termsAndConditions.webp": [
		66405,
		6405
	],
	"./headers/tokenHistory.webp": [
		304,
		304
	],
	"./headers/tokenPurchases.webp": [
		80736,
		736
	],
	"./headers/tokenWallet.webp": [
		67593,
		7593
	],
	"./headers/topupActivationWallet.webp": [
		79262,
		9262
	],
	"./headers/topupUSDT.webp": [
		11783,
		1783
	],
	"./headers/trackingInstallments.webp": [
		10814,
		814
	],
	"./headers/transferHistory.webp": [
		86288,
		6288
	],
	"./headers/usdtHistory.webp": [
		16561,
		6561
	],
	"./headers/userResource.webp": [
		53156,
		3156
	],
	"./headers/videoMarketing.webp": [
		39990,
		9990
	],
	"./headers/walletHistory.webp": [
		15442,
		5442
	],
	"./headers/walletTransfer.webp": [
		94473,
		4473
	],
	"./headers/withdrawal.webp": [
		532,
		532
	],
	"./headers/withdrawalHistory.webp": [
		96396,
		6396
	],
	"./headers/withdrawalRequest.webp": [
		44729,
		4729
	],
	"./home/bg.jpg": [
		31031,
		1031
	],
	"./home/crowdfunding.png": [
		17424,
		7424
	],
	"./home/hero/1.jpg": [
		29702,
		9702
	],
	"./home/hero/2.jpg": [
		57457,
		7457
	],
	"./home/hero/3.jpg": [
		43124,
		3124
	],
	"./home/icons/features.svg": [
		76604,
		6604
	],
	"./home/icons/powerfull.svg": [
		78035,
		8035
	],
	"./home/icons/safe.svg": [
		83722,
		3722
	],
	"./home/icons/speed.svg": [
		44538,
		4538
	],
	"./home/map.png": [
		69882,
		9882
	],
	"./home/marketmaker.png": [
		52004,
		2004
	],
	"./home/mmi.png": [
		54831,
		4831
	],
	"./home/mmp/1.jpg": [
		66510,
		6510
	],
	"./home/mmp/2.jpg": [
		81529,
		1529
	],
	"./home/mmp/3.jpg": [
		37180,
		7180
	],
	"./home/mmp/4.jpg": [
		91591,
		1591
	],
	"./home/permissions/1.jpg": [
		5336,
		5336
	],
	"./home/permissions/2.png": [
		89015,
		9015
	],
	"./home/permissions/3.jpg": [
		45258,
		5258
	],
	"./home/risks.jpg": [
		81320,
		1320
	],
	"./home/shadow.png": [
		61778,
		1778
	],
	"./icon3d.png": [
		44382,
		4382
	],
	"./icons/accepted.svg": [
		9082,
		9082
	],
	"./icons/bemchain.png": [
		65794,
		5794
	],
	"./icons/cmc.png": [
		97154,
		7154
	],
	"./icons/coins/bcn.png": [
		50847,
		847
	],
	"./icons/coins/tim.png": [
		37528,
		7528
	],
	"./icons/coins/trx.png": [
		13048,
		3048
	],
	"./icons/coins/usdt.png": [
		52520,
		2520
	],
	"./icons/crown.svg": [
		81346,
		1346
	],
	"./icons/crown_black.svg": [
		23118,
		3118
	],
	"./icons/failed.svg": [
		77170,
		7170
	],
	"./icons/forbidden.svg": [
		30520,
		520
	],
	"./icons/identity.svg": [
		8063,
		8063
	],
	"./icons/info.svg": [
		87853,
		7853
	],
	"./icons/kyc.svg": [
		39384,
		9384
	],
	"./icons/menu/activation.svg": [
		50307,
		307
	],
	"./icons/menu/activeLeftUsers.svg": [
		1342,
		1342
	],
	"./icons/menu/activeRightUsers.svg": [
		76183,
		6183
	],
	"./icons/menu/binaryOption.svg": [
		13227,
		3227
	],
	"./icons/menu/bonus.svg": [
		78904,
		8904
	],
	"./icons/menu/cryptoDeposit.svg": [
		22398,
		2398
	],
	"./icons/menu/currentDeposit.svg": [
		67256,
		7256
	],
	"./icons/menu/customerSupport.svg": [
		49032,
		9032
	],
	"./icons/menu/dailyBalance.svg": [
		66522,
		6522
	],
	"./icons/menu/dailyLeftInvestment.svg": [
		754,
		754
	],
	"./icons/menu/dailyRightInvestment.svg": [
		17783,
		7783
	],
	"./icons/menu/debts.svg": [
		81659,
		1659
	],
	"./icons/menu/defi.svg": [
		25225,
		5225
	],
	"./icons/menu/defiWallet.svg": [
		42330,
		2330
	],
	"./icons/menu/depositsPortals.svg": [
		48383,
		8383
	],
	"./icons/menu/discount.svg": [
		87334,
		7334
	],
	"./icons/menu/donate.svg": [
		1138,
		1138
	],
	"./icons/menu/downloadApp.svg": [
		11948,
		1948
	],
	"./icons/menu/earlyTermination.svg": [
		65322,
		5322
	],
	"./icons/menu/exit.svg": [
		55475,
		5475
	],
	"./icons/menu/foreignExchange.svg": [
		94842,
		4842
	],
	"./icons/menu/forex.svg": [
		36947,
		6947
	],
	"./icons/menu/forexWallet.svg": [
		15672,
		5672
	],
	"./icons/menu/genealogy.svg": [
		33230,
		3230
	],
	"./icons/menu/home.svg": [
		78822,
		8822
	],
	"./icons/menu/incomeHistory.svg": [
		42734,
		2734
	],
	"./icons/menu/internalExchange.svg": [
		99827,
		9827
	],
	"./icons/menu/investmentDashboard.svg": [
		98420,
		8420
	],
	"./icons/menu/investmentPackage.svg": [
		62896,
		2896
	],
	"./icons/menu/luckySpin.svg": [
		93033,
		3033
	],
	"./icons/menu/masterCardApplication.svg": [
		3915,
		3915
	],
	"./icons/menu/membersLoan.svg": [
		1770,
		1770
	],
	"./icons/menu/mmb.svg": [
		13169,
		3169
	],
	"./icons/menu/mmc.svg": [
		98784,
		8784
	],
	"./icons/menu/mmf.svg": [
		84589,
		4589
	],
	"./icons/menu/mmi.svg": [
		70234,
		234
	],
	"./icons/menu/myPackages.svg": [
		99022,
		9022
	],
	"./icons/menu/myProfile.svg": [
		13456,
		3456
	],
	"./icons/menu/news.svg": [
		13374,
		3374
	],
	"./icons/menu/nft.svg": [
		87445,
		7445
	],
	"./icons/menu/nftWallet.svg": [
		8046,
		8046
	],
	"./icons/menu/noData.svg": [
		14506,
		4506
	],
	"./icons/menu/privacyPolicy.svg": [
		28135,
		8135
	],
	"./icons/menu/stockMarket.svg": [
		88703,
		8703
	],
	"./icons/menu/termsAndConditions.svg": [
		46313,
		6313
	],
	"./icons/menu/token.svg": [
		5162,
		5162
	],
	"./icons/menu/tokenWallet.svg": [
		91741,
		1741
	],
	"./icons/menu/totalLeftInvestment.svg": [
		42531,
		2531
	],
	"./icons/menu/totalRightInvestment.svg": [
		94408,
		4408
	],
	"./icons/menu/usdt.svg": [
		39695,
		9695
	],
	"./icons/menu/userResource.svg": [
		79738,
		9738
	],
	"./icons/menu/videoMarketing.svg": [
		99352,
		9352
	],
	"./icons/menu/walletHistory.svg": [
		58336,
		8336
	],
	"./icons/menu/walletTransfer.svg": [
		5513,
		5513
	],
	"./icons/menu/walletWithdrawal.svg": [
		40461,
		461
	],
	"./icons/mmp.png": [
		97467,
		7467
	],
	"./icons/noData.svg": [
		82152,
		2152
	],
	"./icons/pass.svg": [
		22746,
		2746
	],
	"./icons/pending.svg": [
		75158,
		5158
	],
	"./icons/person.svg": [
		50610,
		610
	],
	"./icons/rejected.svg": [
		923,
		923
	],
	"./icons/sponsor/balance.png": [
		25646,
		5646
	],
	"./icons/sponsor/dailyLeft.png": [
		82606,
		2606
	],
	"./icons/sponsor/dailyRight.png": [
		50883,
		883
	],
	"./icons/sponsor/leftUsers.png": [
		47951,
		7951
	],
	"./icons/sponsor/rightUsers.png": [
		35014,
		5014
	],
	"./icons/sponsor/totalLeft.png": [
		42391,
		2391
	],
	"./icons/sponsor/totalRight.png": [
		82760,
		2760
	],
	"./icons/star.svg": [
		5125,
		5125
	],
	"./icons/submit.svg": [
		30889,
		889
	],
	"./icons/success.svg": [
		75970,
		5970
	],
	"./icons/ticket.svg": [
		31793,
		1793
	],
	"./icons/usd.svg": [
		32967,
		2967
	],
	"./icons/user.svg": [
		42360,
		2360
	],
	"./icons/warn.svg": [
		20601,
		601
	],
	"./kyc/Selfie/Sfalse1.jpg": [
		11294,
		1294
	],
	"./kyc/Selfie/Sfalse2.jpg": [
		2793,
		2793
	],
	"./kyc/Selfie/Sfalse3.jpg": [
		5004,
		5004
	],
	"./kyc/Selfie/Sfalse4.jpg": [
		65239,
		5239
	],
	"./kyc/Selfie/selfieCorrect.jpg": [
		23345,
		3345
	],
	"./kyc/idBack/0.jpg": [
		76077,
		6077
	],
	"./kyc/idBack/1.jpg": [
		32624,
		2624
	],
	"./kyc/idBack/2.jpg": [
		63935,
		3935
	],
	"./kyc/idBack/3.jpg": [
		27586,
		7586
	],
	"./kyc/idBack/4.jpg": [
		40497,
		497
	],
	"./kyc/idBack/5.jpg": [
		61972,
		1972
	],
	"./kyc/idBack/6.jpg": [
		63779,
		3779
	],
	"./kyc/idFront/0.jpg": [
		31233,
		1233
	],
	"./kyc/idFront/1.jpg": [
		53188,
		3188
	],
	"./kyc/idFront/2.jpg": [
		53235,
		3235
	],
	"./kyc/idFront/3.jpg": [
		81622,
		1622
	],
	"./kyc/idFront/4.jpg": [
		38493,
		8493
	],
	"./kyc/idFront/5.jpg": [
		12928,
		2928
	],
	"./kyc/idFront/6.jpg": [
		95919,
		5919
	],
	"./kyc/passport/0.jpg": [
		3241,
		3241
	],
	"./kyc/passport/1.jpg": [
		47980,
		7980
	],
	"./kyc/passport/2.jpg": [
		8603,
		8603
	],
	"./kyc/passport/3.jpg": [
		23646,
		3646
	],
	"./kyc/passport/4.jpg": [
		70981,
		981
	],
	"./kyc/passport/5.jpg": [
		27016,
		7016
	],
	"./kyc/passport/6.jpg": [
		37943,
		7943
	],
	"./loginBack.webp": [
		21994,
		1994
	],
	"./loginBackBF.webp": [
		43066,
		3066
	],
	"./logo.png": [
		62077,
		2077
	],
	"./logo512.png": [
		4981,
		4981
	],
	"./logoMMI.svg": [
		28272,
		8272
	],
	"./logo_2025.png": [
		50243,
		243
	],
	"./logo_2D.png": [
		45368,
		2987
	],
	"./logo_fall.webp": [
		34017,
		6398
	],
	"./logo_org.png": [
		3914,
		3914
	],
	"./logo_x.png": [
		30548,
		548
	],
	"./midyear.svg": [
		31029,
		1029
	],
	"./migrateImg.png": [
		34148,
		4148
	],
	"./millionaires/bg.webp": [
		27210,
		7210
	],
	"./millionaires/club.webp": [
		85433,
		5433
	],
	"./millionaires/clubRanks/1.svg": [
		80900,
		900
	],
	"./millionaires/clubRanks/10.svg": [
		61052,
		1052
	],
	"./millionaires/clubRanks/2.svg": [
		24023,
		4023
	],
	"./millionaires/clubRanks/3.svg": [
		9638,
		9638
	],
	"./millionaires/clubRanks/4.svg": [
		39081,
		9081
	],
	"./millionaires/clubRanks/5.svg": [
		34840,
		4840
	],
	"./millionaires/clubRanks/6.svg": [
		85579,
		5579
	],
	"./millionaires/clubRanks/7.svg": [
		70970,
		970
	],
	"./millionaires/clubRanks/8.svg": [
		57645,
		7645
	],
	"./millionaires/clubRanks/9.svg": [
		58700,
		8700
	],
	"./millionaires/gift.webp": [
		87263,
		7263
	],
	"./millionaires/globalRanks/1.svg": [
		57791,
		7791
	],
	"./millionaires/globalRanks/10.svg": [
		74205,
		4205
	],
	"./millionaires/globalRanks/2.svg": [
		78764,
		8764
	],
	"./millionaires/globalRanks/3.svg": [
		26125,
		6125
	],
	"./millionaires/globalRanks/4.svg": [
		75221,
		7602
	],
	"./millionaires/globalRanks/5.svg": [
		1331,
		1331
	],
	"./millionaires/globalRanks/6.svg": [
		40320,
		320
	],
	"./millionaires/globalRanks/7.svg": [
		54705,
		4705
	],
	"./millionaires/globalRanks/8.svg": [
		87174,
		7174
	],
	"./millionaires/globalRanks/9.svg": [
		92503,
		2503
	],
	"./millionaires/logo.webp": [
		14174,
		4174
	],
	"./millionaires/lottery.webp": [
		94266,
		1885
	],
	"./millionaires/point1.svg": [
		23524,
		3524
	],
	"./millionaires/point2.svg": [
		94327,
		4327
	],
	"./millionaires/ticket.svg": [
		21411,
		1411
	],
	"./ranks/crownAmbassadorI.svg": [
		41035,
		1035
	],
	"./ranks/crownAmbassadorII.svg": [
		23848,
		3848
	],
	"./ranks/crownAmbassadorl.svg": [
		28390,
		8390
	],
	"./ranks/crownDiamond.svg": [
		84347,
		4347
	],
	"./ranks/doubleCrown Diamond.svg": [
		7372,
		7372
	],
	"./ranks/doubleCrownDiamond.svg": [
		876,
		876
	],
	"./ranks/emeraldLeader.svg": [
		25155,
		5155
	],
	"./ranks/founderAmbassador.svg": [
		94966,
		4966
	],
	"./ranks/leader.svg": [
		40371,
		371
	],
	"./ranks/presenter.svg": [
		16400,
		6400
	],
	"./ranks/rubyLeader.svg": [
		16091,
		6091
	],
	"./ranks/sapphireLeader.svg": [
		4165,
		4165
	],
	"./ranks/starter.svg": [
		80545,
		545
	],
	"./ranks/superCrownAmbassadorII.svg": [
		19543,
		9543
	],
	"./ranks/superCrownAmbassadorl.svg": [
		37567,
		7567
	],
	"./ranks/trainer.svg": [
		87351,
		7351
	],
	"./ranks/tripleCrownDiamond.svg": [
		26715,
		6715
	],
	"./raw.jpg": [
		95884,
		5884
	],
	"./stars/1.svg": [
		60819,
		819
	],
	"./stars/2.svg": [
		40064,
		64
	],
	"./stars/3.svg": [
		76017,
		6017
	],
	"./stars/desktop.svg": [
		74654,
		4654
	],
	"./stars/empire.svg": [
		54718,
		4718
	],
	"./stars/frameDesktop.webp": [
		60529,
		529
	],
	"./stars/frameMobile.webp": [
		97965,
		7965
	],
	"./stars/mainLogo.svg": [
		63788,
		3788
	],
	"./stars/mobile.svg": [
		20996,
		996
	],
	"./stars/noAkhtaran.svg": [
		27519,
		7519
	],
	"./stars/ticket.svg": [
		71138,
		8757
	],
	"./stars/twinLarge.svg": [
		5777,
		5777
	],
	"./stars/twinSmall.svg": [
		44457,
		4457
	],
	"./success.png": [
		53475,
		3475
	],
	"./tokens/bcn.svg": [
		63562,
		3562
	],
	"./tokens/bems.svg": [
		3418,
		3418
	],
	"./tokens/bsm.svg": [
		31689,
		1689
	],
	"./tokens/tim.svg": [
		79621,
		9621
	],
	"./true.png": [
		4212,
		4212
	],
	"./underMaintenance.png": [
		45291,
		5291
	],
	"./verification/level_0.svg": [
		60527,
		527
	],
	"./verification/level_1.svg": [
		75569,
		7950
	],
	"./verification/level_2.svg": [
		52125,
		2125
	],
	"./verification/level_3.svg": [
		97852,
		7852
	],
	"./verification/level_4.svg": [
		56131,
		6131
	],
	"./wallets/activation.jpg": [
		66545,
		6545
	],
	"./wallets/currentDeposit.jpg": [
		95006,
		5006
	],
	"./wallets/defi.jpg": [
		70495,
		495
	],
	"./wallets/discount.jpg": [
		19860,
		9860
	],
	"./wallets/forex.jpg": [
		98019,
		8019
	],
	"./wallets/goldenReward.jpg": [
		18123,
		504
	],
	"./wallets/icons/activation.svg": [
		95616,
		5616
	],
	"./wallets/icons/currentDeposit.svg": [
		33071,
		3071
	],
	"./wallets/icons/defi.svg": [
		49494,
		9494
	],
	"./wallets/icons/discount.svg": [
		41753,
		1753
	],
	"./wallets/icons/forex.svg": [
		58382,
		8382
	],
	"./wallets/icons/nft.svg": [
		77840,
		5459
	],
	"./wallets/icons/token.svg": [
		64175,
		4175
	],
	"./wallets/icons/usdt.svg": [
		21708,
		1708
	],
	"./wallets/nft.jpg": [
		7453,
		7453
	],
	"./wallets/token.jpg": [
		57006,
		7006
	],
	"./wallets/usdt.jpg": [
		79713,
		9713
	],
	"./warning.png": [
		46070,
		6070
	],
	"./warning.svg": [
		1004,
		1004
	],
	"./warning2.png": [
		21590,
		1590
	],
	"./xLogo.png": [
		8123,
		8123
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85680;
module.exports = webpackAsyncContext;